import { render, staticRenderFns } from "./SendCardDialog.vue?vue&type=template&id=13cba02c&scoped=true&"
import script from "./SendCardDialog.vue?vue&type=script&lang=js&"
export * from "./SendCardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cba02c",
  null
  
)

export default component.exports